import { api } from '@/core/api/';
const baseUrl = 'api/medicaidcertification';

export const get = (params) => api.get(`${baseUrl}`, { params });
export const getLog = (id) => api.get(`${baseUrl}/${id}/log`);
export const changeStatus = (id, payload) =>
  api.put(`${baseUrl}/${id}/status`, payload);
export const applyAction = async (payload) => {
  return await api.put(`${baseUrl}/apply-action`, payload);
};
export const revertStatus = async (id, payload) => {
  return api.put(`${baseUrl}/${id}/status/revert`, payload);
};
